module.exports = __webpack_public_path__ + "img/british-Airways.ecfa55e1.webp";